export default [{
    path: '/trade/cashier',
    name: 'cashier',
    component: resolve => require(['./cashier.vue'], resolve)
}, {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
        requiresAuth: true
    },
    children: [{
        path: '/System/Company/:CompanyID/trade/list',
        name: 'tradelist',
        component: resolve => require(['./tradeorderlist.vue'], resolve),
    }, {
        path: '/System/Company/:CompanyID/trade/details',
        // name: 'tradedetails',
        component: resolve => require(['./tradeorderdetail.vue'], resolve),
    }, 
    // {
    //     path: '/System/Company/:CompanyID/tradeorder/list',
    //     // name: 'tradeorderlist',
    //     component: resolve => require(['./list.vue'], resolve)
    // }, 
    {
        path: '/System/Company/:CompanyID/tradeorder/detail',
        name: 'tradeorderdetail',
        component: resolve => require(['./details.vue'], resolve)
    }],
}]



// WEBPACK FOOTER //
// ./src/views/trade/router.js